// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b257da72","298":"1b5544eb","453":"13fc41d2","455":"d6de0107","977":"844bb201"}[chunkId] + ".chunk.js";
};